var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _g4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaradvertise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "649.863px",
    height: "138.664px",
    viewBox: "0 0 649.863 138.664",
    enableBackground: "new 0 0 649.863 138.664",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.511,85.986c0-6.334,0.424-31.563,1.689-38.003c-2.533,1.055-4.75,3.378-6.439,6.651 c-7.6-4.328-14.884-5.701-21.957-5.701c-18.264,0-30.72,9.079-30.72,22.379c0,5.596,2.956,11.399,8.128,16.258 c4.328,4.012,6.969,5.594,14.146,8.34c-11.612,16.258-14.251,19.74-23.647,32.092c-0.317,0.422,0.951,1.795,1.266,1.795 c4.857-6.967,6.757-8.129,12.562-8.129c6.756,0,9.924,0.951,22.803,4.961c1.584-1.055,9.923-7.811,10.769-7.811 c0.844,0,5.277,5.594,11.398,8.442c3.803-3.377,8.023-8.021,11.087-12.032c0.315-0.422-0.95-1.162-1.372-0.845 c-0.739,0.738-2.323,2.429-3.273,2.429c-0.844,0-1.688-0.105-2.322-0.527c-3.59-2.322-4.117-3.168-4.117-8.023V85.986 L340.511,85.986z M328.688,94.432c-2.638,0.422-6.123,0.738-9.079,0.738c-3.589,0-6.86-0.316-10.133-1.055 c5.067-6.863,8.761-12.035,11.19-15.623c8.021-11.93,9.71-14.253,10.662-14.253c0.315,0,0.528,0.317,0.528,0.635 c0,0.422-0.106,0.527-0.635,1.477C328.9,70.785,328.9,77.225,328.688,94.432L328.688,94.432z M328.688,115.229 c0,1.16-0.315,1.689-0.948,1.689c-0.212,0-1.268-0.211-2.43-0.318c-6.016-0.844-12.034-1.371-16.256-1.371 c-4.646,0-8.234,0.422-12.562,1.371c-1.055,0.213-1.9,0.424-2.85,0.424c-0.212,0-0.317-0.211-0.317-0.526 c0-0.847,2.005-3.906,6.123-9.078c3.167-3.905,5.383-7.073,8.128-10.875c4.856,1.688,10.239,1.795,15.94,1.688l5.172-0.104V115.229 L328.688,115.229z M324.255,63.395c1.583,1.268,2.112,1.901,2.112,2.64c0,1.477-14.675,21.43-19.53,27.658 c-6.546-2.322-9.08-3.695-12.88-6.967c-4.961-4.328-7.812-9.818-7.812-14.779c0-8.446,8.868-15.203,20.058-15.203 C312.536,56.744,318.026,58.751,324.255,63.395L324.255,63.395z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.272,48.405c0-0.528-0.211-0.633-0.528-0.633c-0.527,0-0.949,0.315-2.216,1.477c-2.006,1.901-3.379,2.956-4.118,2.956 c-0.949,0-6.121-1.372-8.023-1.372c-1.582,0-3.061,0.424-3.061,0.846c0,0.211,0.104,0.211,0.526,0.211 c4.646,0,8.129,1.372,8.129,3.061V67.09c0,0.317,0,0.528-0.211,0.528c-0.315,0-1.373-0.739-2.006-1.162 c-0.315-0.211-0.526-0.317-0.739-0.317c-0.211,0-1.055,0.528-2.005,0.95l-13.513,6.544c-1.162,0.529-1.9,0.74-1.9,1.373v40.959 c0,1.584-1.9,2.535-1.9,3.062c0,0.949,10.24,8.445,11.19,8.445c1.794,0,8.341-5.597,9.817-5.597c0.527,0,0.633,0.211,0.633,1.795 v4.117c0,0.737,0.212,1.373,0.634,1.373c1.688,0,14.356-9.187,14.356-10.662c0-0.317-0.211-0.529-0.526-0.529 c-0.528,0-2.744,1.479-3.272,1.479c-0.634,0-1.267-1.057-1.267-2.322V48.405L385.272,48.405z M364.897,75.852 c0-1.373,0.95-2.639,2.005-2.639c2.008,0,9.079,4.857,9.079,6.545v36.42c0,2.217-0.737,3.59-2.217,3.59 c-1.899,0-8.867-5.805-8.867-8.129V75.852L364.897,75.852z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.697,100.871c5.805-9.184,12.35-18.369,18.262-27.658c0.422-0.74,0.633-1.162,0.633-1.373 c0-0.422-0.422-0.633-0.844-0.633c-0.844,0-1.373,1.9-2.746,1.9c-1.16,0-8.127-6.861-10.133-6.861c-0.74,0-5.809,3.167-7.707,4.117 c-3.906,2.006-6.756,2.744-6.756,4.115v40.645c0,1.9-1.162,2.744-1.162,3.59c0,0.738,1.162,1.479,7.707,4.855l7.707,4.012 c7.811-4.223,13.723-7.496,13.723-8.656c0-0.422-0.104-0.633-0.422-0.633c-0.951,0-2.324,0.949-4.645,0.949 c-2.006,0-9.396-2.006-11.932-4.539c-1.055-1.162-1.688-4.117-1.688-8.34v-5.49H446.697z M446.697,84.719 c0-9.5,0.211-11.398,1.266-11.398c0.949,0,7.602,9.289,7.602,10.556c0,1.162-4.014,6.969-8.656,13.937h-0.211V84.719 L446.697,84.719z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480.976,77.119c0-1.584,0.738-2.641,1.795-2.641c2.428,0,6.861,5.278,8.34,9.817c0.527,1.584,0.949,2.006,1.688,2.006 c0.424,0,0.738-0.526,0.738-1.477c0.105-2.113,0.424-3.591,1.373-7.074c0.527-2.321,0.74-3.483,0.74-4.328 c0-2.428-6.547-6.756-7.814-6.756c-1.158,0-4.539,5.49-6.967,5.49c-1.055,0-6.65-5.174-8.021-5.174 c-0.211,0-0.635,0.317-1.268,1.057l-3.799,4.539c-0.424,0.526-0.848,1.373-0.848,1.795c0,0.526,0.318,0.949,1.373,1.582 c3.166,1.795,3.377,2.324,3.377,9.08v29.771c0,2.428-0.211,3.061-1.158,4.012c-0.424,0.422-0.527,0.633-0.527,1.055 c0,1.162,8.656,7.496,9.5,7.496c0,0,0.844-0.211,4.539-2.217c4.117-2.322,4.117-2.744,4.117-3.062c0-0.314-0.635-0.633-1.9-1.477 c-4.115-2.641-5.277-4.328-5.277-7.92V77.119L480.976,77.119z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M510.537,78.596c0-2.215,0.422-2.955,2.006-2.955h7.918c3.166,0,4.645-1.795,4.645-5.805c0-0.633-0.422-0.951-1.162-0.951 h-11.822c-1.162,0-1.584-0.528-1.584-1.477v-6.862c0-0.634-0.211-1.057-0.527-1.057c-0.633,0-0.846,0.528-3.904,3.167 c-8.234,7.391-9.607,8.551-9.607,9.395c0,1.48,4.75,3.59,4.75,5.385v33.888c0,3.59-0.422,5.276-1.371,6.758 c-0.316,0.313-0.316,0.422-0.316,0.633c0,0.634,12.141,8.867,12.562,8.867c0.316,0,0.738-0.104,1.268-0.422l10.135-5.384 c0.949-0.424,1.688-1.161,1.688-1.69c0-0.633-0.738-1.055-2.215-1.055c-4.646,0-12.459,0-12.459-9.187V78.596H510.537z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M531.125,116.285c0,2.109-0.107,2.744-0.74,3.693c-0.211,0.315-0.314,0.424-0.314,0.635c0,0.738,5.172,6.648,6.967,6.648 c0.633,0,6.967-4.644,6.967-5.91c0-0.211-0.211-0.527-0.844-0.847c-1.9-1.266-2.746-2.85-2.746-5.383v-35.47 c0-2.639,0.211-3.801,0.846-4.855c0.211-0.318,0.211-0.529,0.211-0.633c0-1.057-2.006-2.324-4.645-4.54 c-3.062-2.64-4.117-3.484-4.646-3.484c-1.373,0-4.854,6.44-4.854,7.073c0,0.422,0.525,1.162,1.371,2.111 c1.688,1.9,2.428,3.061,2.428,4.539V116.285L531.125,116.285z M538.619,51.889c-3.906,0-7.283,3.378-7.283,7.255 c0,0.731,0.422,1.358,0.844,1.358c0.316,0,0.424-0.21,0.527-0.314c1.162-2.297,2.006-3.655,4.223-3.655 c0.529,0,2.641,0.209,3.062,0.209c1.373,0,1.898-0.525,1.898-2.004C541.892,52.944,540.73,51.889,538.619,51.889L538.619,51.889z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M581.796,103.09c0-2.006,0.211-2.852,1.055-4.014c0.316-0.422,0.424-0.633,0.424-0.844c0-1.9-10.559-6.019-10.559-7.918 c0-0.316,0.846-1.582,1.9-3.273c4.33-6.332,8.34-14.883,8.34-16.15c0-0.526-0.738-1.162-1.16-1.162 c-0.635,0-2.955,6.333-4.117,6.333c-1.373,0-8.34-9.605-10.449-9.605c-0.426,0-2.008,0.844-6.652,3.272l-5.488,2.851 c-2.639,1.373-2.957,1.898-2.957,4.223v15.939c0,1.268-1.055,3.062-1.055,4.014c0,2.109,6.756,4.75,6.756,7.07 c0,0.424-0.422,1.268-1.689,2.852c-4.961,6.756-8.445,14.463-8.445,19.002c0,2.006,0.527,3.59,1.162,3.59 c0.738,0,0.949-0.211,0.949-0.951c0-3.801,0.318-6.649,1.584-6.649c0.527,0,12.668,5.912,15.309,5.912 c0.738,0,9.289-5.067,11.084-5.912c3.695-1.688,4.012-2.321,4.012-7.494V103.09H581.796z M569.234,81.869 c2.006,2.746,2.85,4.012,2.85,4.646c0,2.53-6.229,8.762-7.389,8.762c-1.162,0-3.273-2.957-3.273-4.646V76.803 c0-1.584,0.529-2.535,1.27-2.535c0.947,0,1.793,1.162,4.854,5.385L569.234,81.869L569.234,81.869z M572.505,113.855 c0,3.905-0.525,5.596-1.477,5.596c-1.162,0-3.59-1.057-7.393-3.273c-5.91-3.484-6.967-3.906-6.967-5.383 c0-2.111,8.447-11.719,9.502-11.719c3.377,0,6.334,4.328,6.334,9.502V113.855L572.505,113.855z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M600.91,100.871c5.805-9.184,12.35-18.369,18.262-27.658c0.422-0.74,0.633-1.162,0.633-1.373 c0-0.422-0.422-0.633-0.844-0.633c-0.844,0-1.373,1.9-2.746,1.9c-1.16,0-8.127-6.861-10.133-6.861 c-0.738,0-5.807,3.167-7.705,4.117c-3.906,2.006-6.758,2.744-6.758,4.115v40.645c0,1.9-1.162,2.744-1.162,3.59 c0,0.738,1.162,1.479,7.709,4.855l7.705,4.012c7.811-4.223,13.723-7.496,13.723-8.656c0-0.422-0.104-0.633-0.422-0.633 c-0.951,0-2.324,0.949-4.645,0.949c-2.006,0-9.396-2.006-11.93-4.539c-1.057-1.162-1.688-4.117-1.688-8.34V100.871L600.91,100.871z  M600.91,84.719c0-9.5,0.211-11.398,1.266-11.398c0.951,0,7.602,9.289,7.602,10.556c0,1.162-4.012,6.969-8.656,13.937h-0.211 V84.719L600.91,84.719z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M635.187,77.119c0-1.584,0.738-2.641,1.797-2.641c2.428,0,6.861,5.278,8.34,9.817c0.525,1.584,0.947,2.006,1.688,2.006 c0.422,0,0.738-0.526,0.738-1.477c0.105-2.113,0.424-3.591,1.371-7.074c0.529-2.321,0.74-3.483,0.74-4.328 c0-2.428-6.545-6.756-7.812-6.756c-1.16,0-4.539,5.49-6.967,5.49c-1.055,0-6.65-5.174-8.023-5.174 c-0.211,0-0.633,0.317-1.266,1.057l-3.801,4.539c-0.424,0.526-0.846,1.373-0.846,1.795c0,0.526,0.316,0.949,1.371,1.582 c3.168,1.795,3.379,2.324,3.379,9.08v29.771c0,2.428-0.211,3.061-1.158,4.012c-0.426,0.422-0.529,0.633-0.529,1.055 c0,1.162,8.656,7.496,9.5,7.496c0,0,0.846-0.211,4.539-2.217c4.119-2.322,4.119-2.744,4.119-3.062c0-0.314-0.635-0.633-1.902-1.477 c-4.115-2.641-5.277-4.328-5.277-7.92V77.119L635.187,77.119z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.703,106.256c-5.067-1.479-7.495-2.744-10.875-2.744C6.651,103.512,0,116.812,0,129.375 c0,6.018,1.794,9.289,5.172,9.289c6.651,0,12.036-13.512,14.779-20.584c5.068,1.371,8.763,2.744,15.836,5.594 c6.967,2.852,9.923,3.801,11.717,3.801c7.39,0,28.925-14.674,28.925-32.938c0-11.613-9.079-18.686-24.28-18.686 c-1.479,0-3.062,0.211-4.328,0.211c5.172-8.869,18.263-22.274,24.913-26.497c0.317-0.211,0.424-0.317,0.424-0.633 c0-0.422-0.317-0.95-0.739-0.95c-0.951,0-4.75,3.061-10.451,8.128c-4.224-0.422-7.706-1.055-15.836-4.961 c-5.277-2.534-7.706-3.167-11.4-3.167c-18.474,0-26.287,19.741-26.287,27.236c0,12.562,12.457,18.264,24.386,17.42 C29.665,98.127,28.081,102.139,24.703,106.256L24.703,106.256z M57.322,87.781c5.807,2.428,10.557,8.551,10.662,13.514 c0,0.314-0.633,0.844-1.055,0.844c-0.317,0-0.422-0.106-0.844-1.162c-2.956-6.967-10.979-11.084-22.063-11.084 c-3.378,0-8.13,0.527-12.141,0.527c-15.201,0-18.368-6.227-20.058-9.711c-0.105-0.211-0.211-0.424-0.211-0.635 c0-0.105,0.106-0.316,0.211-0.316c0.317,0,0.846,0.422,1.794,1.373c3.906,3.906,7.39,5.066,15.308,5.066 c4.117,0,11.295-0.422,15.623-0.422C50.145,85.775,54.155,86.408,57.322,87.781L57.322,87.781z M51.939,66.773 c-0.844,1.479-5.279,7.391-6.862,9.608c-3.589,0.211-6.651,0.422-9.711,0.422c-12.246,0-19.53-4.752-19.53-12.458 c0-5.067,3.694-9.711,7.6-9.818C28.714,54.527,39.904,59.384,51.939,66.773L51.939,66.773z M26.813,107.207 c2.745-5.809,4.856-9.293,8.552-14.887c1.899,0,5.279-0.211,7.178-0.211c5.596,0,10.029,0.74,13.407,2.217 c6.123,2.533,10.346,7.812,10.346,13.092c0,6.016-3.167,11.4-6.651,11.4c-3.273,0-9.607-2.111-21.746-7.283 C32.409,109.211,31.037,108.684,26.813,107.207L26.813,107.207z M18.052,117.762c-3.378,10.135-9.079,19.002-12.141,19.002 c-2.112,0-3.589-2.533-3.589-6.229c0-7.705,4.433-13.936,9.818-13.936C14.885,116.6,16.258,117.234,18.052,117.762L18.052,117.762z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.547,78.596c0-2.215,0.422-2.955,2.005-2.955h7.919c3.167,0,4.644-1.795,4.644-5.805c0-0.633-0.422-0.951-1.162-0.951 H93.13c-1.162,0-1.583-0.528-1.583-1.477v-6.862c0-0.634-0.211-1.057-0.527-1.057c-0.634,0-0.846,0.528-3.906,3.167 c-8.234,7.391-9.607,8.551-9.607,9.395c0,1.48,4.75,3.59,4.75,5.385v33.888c0,3.59-0.422,5.276-1.373,6.758 c-0.315,0.313-0.315,0.422-0.315,0.633c0,0.634,12.139,8.867,12.561,8.867c0.317,0,0.739-0.104,1.268-0.422l10.134-5.384 c0.95-0.424,1.69-1.161,1.69-1.69c0-0.633-0.74-1.055-2.217-1.055c-4.646,0-12.458,0-12.458-9.187V78.596L91.547,78.596z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.118,77.119c0-1.584,0.737-2.641,1.794-2.641c2.427,0,6.862,5.278,8.339,9.817c0.528,1.584,0.951,2.006,1.69,2.006 c0.422,0,0.738-0.526,0.738-1.477c0.106-2.113,0.423-3.591,1.372-7.074c0.529-2.321,0.74-3.483,0.74-4.328 c0-2.428-6.545-6.756-7.812-6.756c-1.16,0-4.54,5.49-6.967,5.49c-1.055,0-6.651-5.174-8.023-5.174 c-0.211,0-0.633,0.317-1.266,1.057l-3.8,4.539c-0.424,0.526-0.846,1.373-0.846,1.795c0,0.526,0.317,0.949,1.372,1.582 c3.167,1.795,3.378,2.324,3.378,9.08v29.771c0,2.428-0.211,3.061-1.16,4.012c-0.424,0.422-0.528,0.633-0.528,1.055 c0,1.162,8.656,7.496,9.5,7.496c0,0,0.844-0.211,4.539-2.217c4.118-2.322,4.118-2.744,4.118-3.062c0-0.314-0.633-0.633-1.901-1.477 c-4.116-2.641-5.277-4.328-5.277-7.92V77.119L159.118,77.119z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M407.853,71.896c0.209,0.518,1.062,0.526,1.062,0.526c4.854,0,8.006,4.802,8.006,10.396v31.144 c0,3.166-0.527,4.433-1.898,4.433c-5.279,0-9.078-5.277-9.078-12.668c0,0-0.164-30.812-0.164-32.06s-0.521-2.291-0.521-2.291 c-0.83-0.728-4.926-4.92-5.861-4.92c-0.635,0-6.545,5.172-6.545,6.649c0,0.425,0.316,0.738,1.057,1.371 c2.006,1.584,2.744,3.062,2.744,5.808v31.774c0,3.59-0.316,4.646-1.268,5.49c-0.317,0.316-0.422,0.422-0.422,0.633 c0,1.058,1.162,1.689,6.756,4.75c0.844,0.424,7.602,4.117,7.812,4.117c0.527,0,1.9-0.736,7.178-3.377l1.9-0.951 c7.496-3.799,7.602-4.01,7.602-4.75V80.285c0-3.166,0.633-4.75,1.898-5.807c0.422-0.314,0.527-0.422,0.527-0.634 c0-0.844-11.189-7.811-11.93-7.811c-1.898,0-7.816,4.512-8.543,4.821C408.166,70.857,407.646,71.377,407.853,71.896L407.853,71.896 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.969,115.863c0,2.217-1.266,3.588-3.483,3.588c-2.851,0-7.284-3.273-7.284-6.861v-9.289 c0-1.48,1.266-2.324,3.589-2.324h5.807c0.738,0,1.371,0.844,1.371,1.9V115.863L129.969,115.863z M110.593,89.889 c1.055-0.233,1.024-1.578,1.024-1.578c0-2.746,1.463-13.725,5.369-13.725c8.128,0,12.983,3.588,12.983,9.711v13.092 c0,1.688-1.086,2.023-5.837,2.023c0,0-2.844-0.234-3.665-0.586c-0.821-0.352-1.289,0-1.289,0c-1.583,0.846-5.361,3.205-7.049,3.945 c-1.055,0.528-2.112,0.951-2.428,1.479c0.211,1.688,0.211,4.115,0.211,6.65c0,3.59-0.422,6.123-1.057,8.233 c0,0.738,10.135,8.445,10.875,8.445c1.266,0,7.706-6.229,9.5-6.123v4.961c0,1.058,0.315,1.373,0.95,1.373 c0.949,0,4.855-2.64,8.339-4.539c3.906-2.11,5.594-3.59,5.594-4.646c0-0.314-0.104-0.525-0.315-0.525 c-0.529,0-2.112,1.371-3.484,1.371c-0.528,0-1.055-0.846-1.055-1.689V76.908c0-1.373,0.844-2.43,0.844-3.484 c0-0.422-3.062-1.795-8.657-3.8c-4.646-1.689-10.557-4.012-13.089-4.012c-2.851,0-8.552,15.308-8.552,23.013 C109.807,88.625,109.539,90.123,110.593,89.889L110.593,89.889z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "163.005,62.447 187.339,63.006 187.339,62.517 187.339,61.888  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "165.133,46.285 188.493,53.123 188.62,52.65 188.783,52.043  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "171.371,31.224 192.166,43.875 192.41,43.452 192.725,42.907  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "181.295,18.291 198.106,35.893 198.453,35.547 198.897,35.103  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "194.228,8.367 205.911,29.72 206.335,29.476 206.879,29.162  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "209.289,2.128 215.047,25.778 215.52,25.651 216.127,25.489  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "225.451,0 224.892,24.335 225.381,24.335 226.01,24.335  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "241.613,2.128 234.775,25.489 235.248,25.615 235.855,25.778  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "256.675,8.366 244.023,29.161 244.447,29.406 244.991,29.72  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "269.607,18.291 252.005,35.102 252.351,35.448 252.796,35.893  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "279.532,31.224 258.178,42.907 258.422,43.33 258.737,43.875  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "285.771,46.285 262.12,52.042 262.247,52.515 262.41,53.123  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "287.898,62.447 263.563,61.888 263.563,62.377 263.563,63.006  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "169.129,57.524 187.436,59.682 187.478,59.195 187.533,58.568  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "169.772,52.634 187.821,56.379 187.906,55.897 188.015,55.278  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "172.323,43.113 189.446,49.937 189.613,49.477 189.828,48.886  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "174.21,38.556 190.673,46.846 190.88,46.403 191.146,45.833  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "179.138,30.019 193.91,41.043 194.19,40.643 194.551,40.128  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "182.141,26.105 195.896,38.376 196.21,38.001 196.614,37.52  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "189.11,19.135 200.524,33.608 200.899,33.294 201.381,32.89  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "193.024,16.132 203.132,31.545 203.533,31.265 204.048,30.904  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "201.56,11.203 208.837,28.139 209.28,27.932 209.851,27.667  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "206.118,9.315 211.891,26.821 212.35,26.654 212.941,26.439  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "215.639,6.763 218.283,25.007 218.765,24.922 219.384,24.813  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "220.53,6.119 221.573,24.525 222.061,24.482 222.687,24.427  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "230.388,6.119 228.217,24.427 228.705,24.47 229.332,24.525  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "235.279,6.762 231.521,24.813 232.002,24.898 232.622,25.007  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "244.801,9.313 237.964,26.438 238.424,26.605 239.015,26.82  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "249.358,11.201 241.055,27.666 241.498,27.872 242.068,28.138  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "257.896,16.13 246.858,30.903 247.259,31.184 247.774,31.544  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "261.81,19.133 249.526,32.889 249.9,33.203 250.382,33.607  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "268.781,26.104 254.293,37.518 254.607,37.893 255.012,38.375  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "271.784,30.018 256.356,40.127 256.637,40.527 256.998,41.042  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "276.713,38.555 259.763,45.832 259.97,46.276 260.235,46.846  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "278.602,43.113 261.081,48.886 261.248,49.346 261.463,49.937  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "281.153,52.636 262.895,55.279 262.979,55.761 263.089,56.38  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A7A9AC",
    points: "281.797,57.527 263.377,58.57 263.42,59.057 263.475,59.684  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9CEB4",
    d: "M253.85,46.946c0,0-1.196,0.718-0.319,2.074c0.877,1.356,1.994,1.595,3.509,1.915 c2.233,0.558,5.583,4.147,5.503,8.295c-0.08,4.147-0.239,5.663-0.239,5.663l5.185-7.657l5.264,1.037c0,0,0.16-1.516,0.24-5.663 c0.08-4.147-3.51-8.136-5.504-8.295c-1.356,0-2.632-0.558-3.509-1.914s0.319-2.074,0.319-2.074L253.85,46.946L253.85,46.946z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1917B",
    d: "M258.635,50.057c0.958,0.16,3.111,1.834,3.749,3.908c0,0-1.675-2.792-4.467-3.51 c0,0,2.473,1.037,3.509,3.51c-1.834-2.153-3.19-3.031-4.865-3.43c-1.675-0.399-2.745-1.05-2.951-2.393 c-0.159-1.037,1.276-1.515,1.276-1.515l8.295-5.264c0,0,0.319,1.834,1.755,2.552s1.755,0.718,2.712,0.877s3.35,1.914,3.988,3.988 c0,0-1.675-2.792-4.467-3.509c0.957,0.16,3.11,1.834,3.749,3.908c0,0-1.595-2.792-4.387-3.509c0.957,0.159,3.111,1.834,3.749,3.908 c0,0-1.675-2.792-4.466-3.51c0.957,0.16,3.111,1.835,3.749,3.909c0,0-1.595-2.792-4.387-3.51c0.957,0.16,3.031,1.834,3.669,3.908 c0,0-1.675-2.792-4.466-3.509c0.957,0.16,3.11,1.834,3.749,3.908c0,0-1.675-2.792-4.467-3.509c0.958,0.159,3.111,1.834,3.749,3.908 c0,0-1.595-2.792-4.387-3.51c0.958,0.16,3.031,1.835,3.669,3.908c0,0-1.595-2.792-4.387-3.509c0.958,0.159,3.031,1.834,3.669,3.908 c0,0-1.595-2.792-4.387-3.509c0.957,0.159,3.031,1.834,3.669,3.908c0,0-1.675-2.792-4.466-3.51c0.957,0.16,3.11,1.835,3.749,3.909 c0,0-1.516-2.792-4.308-3.51c0.957,0.16,2.951,1.834,3.589,3.908c0,0-1.675-2.792-4.466-3.509c0.957,0.16,3.11,1.834,3.749,3.908 C263.102,53.566,261.427,50.774,258.635,50.057L258.635,50.057z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M258.556,49.737c0,0-1.276,0.16-1.755-0.957c-0.479-1.117-1.436-2.552-3.031-1.754l6.541-4.148l2.711,4.148L258.556,49.737 L258.556,49.737z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9CEB4",
    d: "M197.054,47.024c0,0,1.196,0.718,0.319,2.074c-0.877,1.355-1.994,1.595-3.51,1.914 c-2.233,0.558-5.583,4.147-5.503,8.295c0.08,4.147,0.239,5.663,0.239,5.663l-5.185-7.657l-5.264,1.037c0,0-0.16-1.516-0.239-5.663 c-0.08-4.147,3.509-8.135,5.503-8.295c1.356,0,2.632-0.559,3.51-1.914c0.877-1.356-0.319-2.074-0.319-2.074L197.054,47.024 L197.054,47.024z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1917B",
    d: "M192.268,50.135c-0.957,0.16-3.111,1.834-3.749,3.908c0,0,1.675-2.792,4.466-3.509 c0,0-2.473,1.037-3.509,3.509c1.834-2.154,3.19-3.031,4.865-3.43c1.675-0.399,2.745-1.05,2.951-2.393 c0.16-1.037-1.276-1.515-1.276-1.515l-8.295-5.264c0,0-0.319,1.834-1.755,2.552c-1.436,0.718-1.755,0.718-2.712,0.877 c-0.957,0.16-3.35,1.914-3.988,3.988c0,0,1.675-2.792,4.467-3.509c-0.958,0.159-3.111,1.834-3.749,3.908 c0,0,1.595-2.792,4.387-3.51c-0.957,0.16-3.11,1.835-3.749,3.909c0,0,1.675-2.792,4.466-3.509c-0.957,0.159-3.11,1.834-3.749,3.908 c0,0,1.595-2.792,4.387-3.51c-0.957,0.16-3.031,1.834-3.669,3.908c0,0,1.675-2.792,4.467-3.509 c-0.958,0.16-3.111,1.834-3.749,3.908c0,0,1.675-2.792,4.467-3.509c-0.957,0.16-3.111,1.834-3.749,3.908 c0,0,1.595-2.792,4.387-3.51c-0.957,0.16-3.031,1.834-3.669,3.909c0,0,1.596-2.792,4.387-3.51c-0.957,0.16-3.031,1.834-3.669,3.908 c0,0,1.595-2.792,4.387-3.509c-0.957,0.16-3.031,1.834-3.669,3.908c0,0,1.675-2.792,4.467-3.509 c-0.958,0.16-3.111,1.834-3.749,3.908c0,0,1.516-2.792,4.307-3.51c-0.957,0.16-2.951,1.834-3.589,3.909c0,0,1.675-2.792,4.467-3.51 c-0.958,0.16-3.111,1.834-3.749,3.908C187.802,53.644,189.477,50.853,192.268,50.135L192.268,50.135z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M192.348,49.815c0,0,1.276,0.16,1.755-0.957c0.479-1.117,1.436-2.552,3.031-1.754l-6.541-4.147l-2.711,4.147 L192.348,49.815L192.348,49.815z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    fill: "#D9CEB4",
    d: "M224.97,29.956c5.583,0,12.731,0.851,20.419,5.264 c8.614,4.945,13.081,12.124,13.081,12.124s1.117,1.595,0.16,2.393l10.335-6.379c1.254-1.045-0.209-3.135-0.209-3.135 s-6.721-10.236-16.985-16.01c-10.21-5.743-20.272-6.7-26.959-6.7c-6.688,0-16.102,1.308-25.843,6.7 c-10.304,5.704-16.986,16.01-16.986,16.01s-1.462,2.09-0.209,3.135l10.335,6.379c-0.957-0.797,0.16-2.393,0.16-2.393 s5.149-7.733,13.081-12.044C212.687,31.311,217.712,30.194,224.97,29.956L224.97,29.956z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "192.773,51.489 179.275,43.062 185.81,32.606 199.308,41.034  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_4_",
    points: "189.415,54.285 182.433,39.985 193.516,34.581 200.498,48.881  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M228.131,53.084c4.735,2.958,10.346,7.468,14.528,15.285c4.685,8.758,4.669,17.213,4.669,17.213 s0.102,1.945-1.132,2.115l12.145,0.066c1.618-0.223,1.484-2.77,1.484-2.77s-0.276-12.243-5.921-22.579 c-5.616-10.281-13.643-16.424-19.313-19.968c-5.672-3.544-14.35-7.423-25.468-8.012c-11.762-0.623-22.89,4.577-22.89,4.577 s-2.348,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.464-3.83,17.476-3.283 C216.996,47.725,221.85,49.44,228.131,53.084L228.131,53.084z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_",
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.285,
    y: 46.582,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 319.2435 185.5598)",
    clipPath: "url(#SVGID_7_)",
    fill: "#D9CEB4",
    width: 15.876,
    height: 0.864
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_8_",
    points: "189.048,53.877 182.065,39.577 193.148,34.173 200.13,48.473  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M227.764,52.676c4.735,2.958,10.346,7.468,14.528,15.285c4.685,8.758,4.669,17.213,4.669,17.213 s0.102,1.945-1.132,2.115l12.145,0.066c1.617-0.223,1.484-2.77,1.484-2.77s-0.276-12.243-5.921-22.579 c-5.616-10.281-13.643-16.424-19.314-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.623-22.889,4.577-22.889,4.577 s-2.348,0.998-1.839,2.548l5.385,10.886c-0.39-1.183,1.403-1.944,1.403-1.944s8.465-3.83,17.477-3.283 C216.629,47.316,221.482,49.032,227.764,52.676L227.764,52.676z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_",
    clipPath: "url(#SVGID_10_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.813,
    y: 45.738,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 320.6612 184.2841)",
    clipPath: "url(#SVGID_11_)",
    fill: "#DFD5BF",
    width: 15.876,
    height: 0.862
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_12_",
    points: "188.68,53.469 181.698,39.169 192.781,33.765 199.763,48.065  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M227.397,52.268c4.735,2.958,10.346,7.468,14.528,15.284c4.685,8.758,4.669,17.214,4.669,17.214 s0.102,1.944-1.132,2.114l12.146,0.066c1.617-0.222,1.484-2.77,1.484-2.77s-0.276-12.242-5.921-22.579 c-5.616-10.281-13.642-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.622-22.89,4.578-22.89,4.578 s-2.347,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.465-3.83,17.476-3.283 C216.262,46.908,221.115,48.624,227.397,52.268L227.397,52.268z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_",
    clipPath: "url(#SVGID_14_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.342,
    y: 44.893,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 322.0883 182.9993)",
    clipPath: "url(#SVGID_15_)",
    fill: "#E5DCCB",
    width: 15.875,
    height: 0.863
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_16_",
    points: "188.313,53.061 181.331,38.761 192.414,33.356 199.396,47.657  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_18_",
    d: "M227.03,51.86c4.735,2.958,10.346,7.468,14.528,15.285c4.685,8.758,4.669,17.214,4.669,17.214 s0.102,1.944-1.132,2.114l12.146,0.066c1.617-0.222,1.484-2.77,1.484-2.77s-0.276-12.242-5.921-22.578 c-5.616-10.281-13.643-16.425-19.313-19.968c-5.672-3.544-14.35-7.423-25.468-8.012c-11.762-0.623-22.89,4.577-22.89,4.577 s-2.348,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.464-3.83,17.476-3.283 C215.895,46.5,220.748,48.216,227.03,51.86L227.03,51.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_",
    clipPath: "url(#SVGID_19_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 179.869,
    y: 44.049,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 323.5086 181.7208)",
    clipPath: "url(#SVGID_21_)",
    fill: "#EBE4D7",
    width: 15.876,
    height: 0.864
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_22_",
    points: "187.945,52.653 180.963,38.354 192.046,32.949 199.028,47.249  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_24_",
    d: "M226.662,51.452c4.735,2.958,10.346,7.468,14.528,15.284c4.685,8.759,4.669,17.214,4.669,17.214 s0.103,1.944-1.132,2.114l12.146,0.066c1.617-0.222,1.484-2.77,1.484-2.77s-0.276-12.242-5.921-22.578 c-5.616-10.281-13.642-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.623-22.89,4.578-22.89,4.578 s-2.347,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.465-3.83,17.476-3.283 C215.527,46.092,220.38,47.808,226.662,51.452L226.662,51.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_25_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_27_",
    clipPath: "url(#SVGID_25_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_24_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.396,
    y: 43.203,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 324.9346 180.4347)",
    clipPath: "url(#SVGID_27_)",
    fill: "#F2ECE3",
    width: 15.876,
    height: 0.864
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_28_",
    points: "192.773,51.489 179.275,43.062 185.81,32.606 199.308,41.034  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_31_",
    points: "187.79,52.513 180.808,38.213 191.891,32.808 198.873,47.108  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_32_",
    d: "M226.506,51.312c4.735,2.958,10.346,7.468,14.528,15.284c4.685,8.759,4.669,17.215,4.669,17.215 s0.102,1.943-1.132,2.113l12.145,0.066c1.618-0.221,1.484-2.77,1.484-2.77s-0.276-12.242-5.921-22.578 c-5.616-10.281-13.643-16.424-19.313-19.968c-5.672-3.544-14.35-7.423-25.468-8.012c-11.762-0.623-22.89,4.577-22.89,4.577 s-2.348,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.464-3.83,17.476-3.283 C215.371,45.952,220.225,47.667,226.506,51.312L226.506,51.312z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_33_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_",
    clipPath: "url(#SVGID_33_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_32_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.526,
    y: 42.698,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 325.4245 179.8946)",
    clipPath: "url(#SVGID_34_)",
    fill: "#F2ECE3",
    width: 15.951,
    height: 1.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_35_",
    points: "187.405,52.085 180.423,37.785 191.506,32.38 198.487,46.681  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_36_",
    d: "M226.122,50.884c4.735,2.958,10.346,7.468,14.528,15.284c4.685,8.759,4.669,17.215,4.669,17.215 s0.102,1.943-1.132,2.113l12.146,0.066c1.617-0.221,1.484-2.77,1.484-2.77s-0.276-12.242-5.921-22.578 c-5.616-10.281-13.642-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.623-22.89,4.577-22.89,4.577 s-2.347,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.465-3.83,17.476-3.283 C214.986,45.524,219.84,47.24,226.122,50.884L226.122,50.884z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_37_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_",
    clipPath: "url(#SVGID_37_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_36_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.079,
    y: 41.812,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 326.9134 178.5537)",
    clipPath: "url(#SVGID_38_)",
    fill: "#EEE7DC",
    width: 15.951,
    height: 1.193
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_39_",
    points: "187.004,51.648 180.023,37.35 191.105,31.946 198.086,46.246  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_40_",
    d: "M225.718,50.45c4.734,2.958,10.345,7.468,14.526,15.284c4.684,8.758,4.668,17.212,4.668,17.212 s0.102,1.944-1.132,2.114l12.145,0.067c1.617-0.222,1.484-2.77,1.484-2.77s-0.275-12.241-5.92-22.577 c-5.615-10.281-13.64-16.424-19.311-19.967c-5.671-3.544-14.348-7.423-25.465-8.013c-11.76-0.623-22.888,4.576-22.888,4.576 s-2.348,0.998-1.838,2.548l5.384,10.886c-0.389-1.183,1.404-1.944,1.404-1.944s8.464-3.829,17.475-3.282 C214.583,45.09,219.437,46.806,225.718,50.45L225.718,50.45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_",
    clipPath: "url(#SVGID_41_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_40_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.618,
    y: 40.919,
    transform: "matrix(-0.848 -0.5299 0.5299 -0.848 328.3733 177.1958)",
    clipPath: "url(#SVGID_42_)",
    fill: "#EAE3D5",
    width: 15.95,
    height: 1.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_43_",
    points: "186.635,51.229 179.653,36.93 190.736,31.525 197.717,45.826  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_44_",
    d: "M225.352,50.029c4.735,2.958,10.346,7.468,14.528,15.285c4.686,8.759,4.669,17.214,4.669,17.214 s0.103,1.944-1.132,2.114l12.146,0.066c1.617-0.222,1.484-2.77,1.484-2.77s-0.276-12.243-5.921-22.579 c-5.616-10.281-13.642-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.623-22.89,4.577-22.89,4.577 s-2.347,0.998-1.838,2.548L187,49.392c-0.389-1.183,1.404-1.945,1.404-1.945s8.465-3.83,17.476-3.283 C214.216,44.669,219.07,46.385,225.352,50.029L225.352,50.029z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_45_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_",
    clipPath: "url(#SVGID_45_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_44_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 182.186,
    y: 40.042,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 329.8987 175.865)",
    clipPath: "url(#SVGID_46_)",
    fill: "#E7DFCE",
    width: 15.951,
    height: 1.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_47_",
    points: "186.233,50.795 179.252,36.496 190.334,31.092 197.314,45.392  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_48_",
    d: "M224.946,49.596c4.734,2.959,10.345,7.468,14.526,15.284c4.684,8.758,4.668,17.213,4.668,17.213 s0.102,1.944-1.132,2.114l12.145,0.066c1.617-0.221,1.484-2.769,1.484-2.769s-0.275-12.242-5.919-22.577 c-5.615-10.28-13.641-16.424-19.311-19.967c-5.671-3.544-14.348-7.423-25.465-8.012c-11.76-0.624-22.888,4.575-22.888,4.575 s-2.347,0.998-1.838,2.548l5.384,10.886c-0.389-1.183,1.404-1.944,1.404-1.944s8.464-3.829,17.475-3.282 C213.812,44.236,218.665,45.952,224.946,49.596L224.946,49.596z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_49_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_",
    clipPath: "url(#SVGID_49_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_48_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 182.723,
    y: 39.151,
    transform: "matrix(-0.848 -0.5299 0.5299 -0.848 331.3563 174.5103)",
    clipPath: "url(#SVGID_50_)",
    fill: "#E3DAC7",
    width: 15.95,
    height: 1.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_51_",
    points: "185.865,50.375 178.883,36.075 189.965,30.67 196.947,44.971  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_52_",
    d: "M224.582,49.174c4.735,2.958,10.346,7.468,14.528,15.284c4.685,8.759,4.669,17.214,4.669,17.214 s0.102,1.945-1.132,2.114l12.146,0.067c1.617-0.223,1.484-2.77,1.484-2.77S256,68.841,250.354,58.505 c-5.616-10.281-13.643-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.762-0.623-22.89,4.578-22.89,4.578 s-2.348,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.464-3.83,17.476-3.283 C213.446,43.814,218.3,45.529,224.582,49.174L224.582,49.174z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_53_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_",
    clipPath: "url(#SVGID_53_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_52_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.291,
    y: 38.271,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 332.8767 173.183)",
    clipPath: "url(#SVGID_54_)",
    fill: "#E0D6C1",
    width: 15.951,
    height: 1.194
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_55_",
    points: "185.464,49.938 178.483,35.64 189.565,30.236 196.546,44.535  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_56_",
    d: "M224.178,48.739c4.734,2.958,10.345,7.468,14.526,15.284c4.684,8.758,4.668,17.213,4.668,17.213 s0.102,1.944-1.132,2.113l12.145,0.067c1.617-0.222,1.484-2.769,1.484-2.769s-0.275-12.242-5.919-22.577 c-5.615-10.28-13.641-16.424-19.311-19.967c-5.671-3.544-14.348-7.423-25.465-8.013c-11.76-0.623-22.888,4.576-22.888,4.576 s-2.347,0.998-1.838,2.548l5.384,10.886c-0.389-1.183,1.404-1.944,1.404-1.944s8.464-3.829,17.475-3.282 C213.043,43.38,217.896,45.095,224.178,48.739L224.178,48.739z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_57_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_",
    clipPath: "url(#SVGID_57_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_56_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.829,
    y: 37.379,
    transform: "matrix(-0.848 -0.5299 0.5299 -0.848 334.339 171.8222)",
    clipPath: "url(#SVGID_58_)",
    fill: "#DCD2BA",
    width: 15.95,
    height: 1.195
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_59_",
    points: "185.095,49.52 178.113,35.22 189.196,29.815 196.177,44.115  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_60_",
    d: "M223.812,48.318c4.735,2.958,10.346,7.468,14.528,15.285c4.686,8.758,4.669,17.213,4.669,17.213 s0.103,1.945-1.132,2.115l12.146,0.066c1.617-0.223,1.484-2.77,1.484-2.77s-0.276-12.243-5.921-22.579 c-5.616-10.281-13.642-16.424-19.313-19.968c-5.672-3.544-14.349-7.423-25.468-8.012c-11.761-0.623-22.89,4.577-22.89,4.577 s-2.347,0.998-1.838,2.548l5.385,10.887c-0.389-1.183,1.404-1.945,1.404-1.945s8.465-3.83,17.476-3.283 C212.676,42.959,217.53,44.674,223.812,48.318L223.812,48.318z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_61_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_",
    clipPath: "url(#SVGID_61_)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_60_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 184.398,
    y: 36.502,
    transform: "matrix(-0.8481 -0.5299 0.5299 -0.8481 335.8637 170.4951)",
    clipPath: "url(#SVGID_62_)",
    fill: "#D9CEB4",
    width: 15.951,
    height: 1.194
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_63_",
    points: "251.383,41.892 264.019,33.687 270.178,43.165 257.542,51.37  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_65_",
    points: "260.959,31.116 254.83,44.879 244.503,40.284 250.632,26.521  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.247,
    y: 37.36,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 20.9264 146.4888)",
    clipPath: "url(#SVGID_66_)",
    fill: "#D9CEB4",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_67_",
    points: "262.363,32.317 256.233,46.081 245.906,41.486 252.036,27.723  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 250.772,
    y: 38.171,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 20.5728 146.9122)",
    clipPath: "url(#SVGID_68_)",
    fill: "#DDD3BB",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_69_",
    points: "263.765,33.515 257.635,47.278 247.308,42.683 253.437,28.92  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.295,
    y: 38.977,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 20.2181 147.327)",
    clipPath: "url(#SVGID_70_)",
    fill: "#E1D8C3",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_71_",
    points: "265.165,34.708 259.036,48.471 248.708,43.876 254.838,30.113  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.817,
    y: 39.779,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 19.8624 147.7343)",
    clipPath: "url(#SVGID_72_)",
    fill: "#E5DCCB",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_73_",
    points: "266.568,35.91 260.439,49.673 250.112,45.078 256.241,31.315  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 252.342,
    y: 40.589,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 19.509 148.1576)",
    clipPath: "url(#SVGID_74_)",
    fill: "#E9E2D3",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_75_",
    points: "267.969,37.103 261.84,50.866 251.513,46.271 257.642,32.508  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 252.865,
    y: 41.392,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 19.1535 148.5648)",
    clipPath: "url(#SVGID_76_)",
    fill: "#EEE7DB",
    width: 15.031,
    height: 1.113
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_77_",
    points: "269.371,38.3 263.241,52.063 252.914,47.468 259.043,33.705  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.388,
    y: 42.198,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 18.8014 148.9863)",
    clipPath: "url(#SVGID_78_)",
    fill: "#F2ECE3",
    width: 15.031,
    height: 1.113
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_79_",
    points: "251.383,41.892 264.019,33.687 270.178,43.165 257.542,51.37  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_81_",
    points: "270.285,38.995 264.156,52.758 253.829,48.163 259.958,34.399  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.709,
    y: 42.849,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 18.5922 149.2526)",
    clipPath: "url(#SVGID_82_)",
    fill: "#F2ECE3",
    width: 15.101,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_83_",
    points: "271.641,40.151 265.511,53.914 255.184,49.319 261.313,35.556  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 254.214,
    y: 43.626,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 18.2525 149.6578)",
    clipPath: "url(#SVGID_84_)",
    fill: "#EDE6D9",
    width: 15.102,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_85_",
    points: "273,41.316 266.87,55.079 256.543,50.484 262.672,36.721  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 254.722,
    y: 44.412,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 17.9062 150.0616)",
    clipPath: "url(#SVGID_86_)",
    fill: "#E8E0CF",
    width: 15.102,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_87_",
    points: "274.354,42.467 268.224,56.23 257.896,51.635 264.026,37.872  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 255.227,
    y: 45.186,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 17.5668 150.4611)",
    clipPath: "url(#SVGID_88_)",
    fill: "#E3D9C6",
    width: 15.102,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_89_",
    points: "275.709,43.626 269.58,57.389 259.252,52.794 265.382,39.031  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 255.733,
    y: 45.966,
    transform: "matrix(0.8387 -0.5446 0.5446 0.8387 17.2233 150.8625)",
    clipPath: "url(#SVGID_90_)",
    fill: "#DED4BD",
    width: 15.102,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_91_",
    points: "277.06,44.805 270.931,58.569 260.603,53.975 266.731,40.21  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_92_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_91_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256.233,
    y: 46.767,
    transform: "matrix(0.8387 -0.5447 0.5447 0.8387 16.876 151.2844)",
    clipPath: "url(#SVGID_92_)",
    fill: "#D9CEB4",
    width: 15.103,
    height: 0.781
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.499,33.587c-0.564,0.538-1.104,1.068-1.675,1.582c-0.562,0.506-1.155,0.996-1.756,1.508l-2.106-2.339 c-0.123,0.125-0.223,0.245-0.336,0.347c-0.122,0.11-0.259,0.204-0.38,0.298l5.019,5.574c0.106-0.111,0.214-0.237,0.336-0.348 c0.114-0.103,0.243-0.189,0.381-0.298l-2.524-2.803c0.572-0.544,1.112-1.075,1.683-1.589c0.571-0.514,1.155-0.996,1.748-1.5 l2.524,2.803c0.107-0.111,0.215-0.237,0.337-0.347c0.114-0.103,0.243-0.189,0.38-0.298l-5.019-5.574 c-0.123,0.126-0.223,0.245-0.337,0.347c-0.122,0.11-0.259,0.204-0.38,0.298L196.499,33.587L196.499,33.587z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96,28.315c0.579,1.061,0.834,3.579-1.263,4.557c-1.48,0.69-3.205,0.211-4.145-1.806 c-0.941-2.017-0.504-3.83,1.246-4.646c0.795-0.371,1.728-0.395,2.517,0C206.142,26.845,206.575,27.49,206.96,28.315L206.96,28.315z  M205.82,33.214c2.216-1.033,3.11-3.216,2.076-5.433c-1.112-2.385-3.483-2.514-5.351-1.643c-2.057,0.959-3.038,3.086-2.023,5.262 C201.514,33.528,203.624,34.238,205.82,33.214L205.82,33.214z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M216.243,21.934c-0.105,0.035-0.196,0.079-0.292,0.101c-0.107,0.024-0.208,0.025-0.307,0.037l1.27,5.502l-0.106,0.024 l-6.346-4.331l-0.417,0.096l1.688,7.308c0.094-0.033,0.185-0.076,0.292-0.101c0.096-0.022,0.197-0.023,0.307-0.037l-1.33-5.759 l0.107-0.025l5.794,4.042c0.281,0.194,0.554,0.401,0.706,0.523l0.321-0.074L216.243,21.934L216.243,21.934z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M227.13,24.812c0.119,1.202-0.631,3.621-2.943,3.701c-1.633,0.057-3.032-1.057-3.11-3.282 c-0.078-2.225,1.033-3.723,2.962-3.79c0.876-0.031,1.744,0.312,2.316,0.983C226.951,23.139,227.098,23.902,227.13,24.812 L227.13,24.812z M224.167,28.876c2.443-0.085,4.119-1.746,4.034-4.189c-0.092-2.63-2.224-3.675-4.284-3.603 c-2.269,0.079-4.002,1.654-3.918,4.054C220.081,27.482,221.745,28.96,224.167,28.876L224.167,28.876z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.472,21.673c-0.175-0.014-0.33-0.013-0.482-0.035c-0.163-0.023-0.322-0.067-0.473-0.1l-1.039,7.395l3.953,0.556 c0.004-0.11-0.002-0.222,0.013-0.33c0.015-0.109,0.05-0.203,0.079-0.321c-0.354-0.005-0.697-0.009-1.045-0.047 c-0.655-0.07-1.312-0.118-1.972-0.233L232.472,21.673L232.472,21.673z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M239.689,23.015c-0.171-0.041-0.324-0.065-0.471-0.11c-0.157-0.048-0.308-0.117-0.452-0.172l-1.282,4.194 c-0.246,0.842-0.448,1.801,0.03,2.601c0.395,0.659,1.013,1.112,2.051,1.43c1.846,0.564,3.383-0.112,4.018-2.189l1.276-4.173 c-0.108-0.021-0.209-0.029-0.303-0.058c-0.104-0.032-0.192-0.082-0.284-0.122l-1.196,3.912c-0.519,1.699-1.485,2.722-3.153,2.212 c-1.793-0.548-2.026-1.663-1.461-3.508L239.689,23.015L239.689,23.015z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M249.738,26.867c-0.159-0.075-0.304-0.13-0.438-0.205c-0.144-0.08-0.277-0.179-0.406-0.262l-3.62,6.531l3.491,1.936 c0.044-0.102,0.078-0.208,0.131-0.304s0.121-0.172,0.188-0.272c-0.328-0.132-0.646-0.258-0.959-0.419 c-0.586-0.299-1.183-0.581-1.757-0.924L249.738,26.867L249.738,26.867z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.483,31.107c-0.138-0.109-0.267-0.196-0.381-0.298c-0.122-0.11-0.229-0.236-0.336-0.348l-2.935,3.26 c-0.579,0.659-1.167,1.443-1.071,2.37c0.079,0.764,0.448,1.436,1.255,2.162c1.434,1.292,3.113,1.328,4.566-0.286l2.92-3.243 c-0.089-0.065-0.177-0.115-0.25-0.181c-0.082-0.073-0.14-0.156-0.206-0.23l-2.737,3.04c-1.188,1.32-2.497,1.839-3.792,0.673 c-1.394-1.255-1.133-2.363,0.158-3.797L256.483,31.107L256.483,31.107z"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008FD3",
    points: "225.775,32.078 237.621,68.425 225.775,84.758  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.8672,
    y1: 54.9067,
    x2: 219.8672,
    y2: 107.5864,
    gradientTransform: "matrix(1 0 0 -1 0 139.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4121,
    style: {
      stopColor: "#95C4EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008FD3"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_17_",
    fill: "url(#SVGID_93_)",
    points: "225.791,32.078 213.945,68.425 225.791,84.758  "
  })))), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008FD3",
    points: "275.889,68.47 244.981,90.969 225.788,84.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.792,
    y1: 63.0566,
    x2: 275.894,
    y2: 63.0566,
    gradientTransform: "matrix(1 0 0 -1 0 139.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008FD3"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_20_",
    fill: "url(#SVGID_94_)",
    points: "275.894,68.485 237.665,68.451 225.792,84.764  "
  })))), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008FD3",
    points: "256.727,127.326 225.779,104.885 225.762,84.709  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.2324,
    y1: 54.9448,
    x2: 241.2324,
    y2: 12.3276,
    gradientTransform: "matrix(1 0 0 -1 0 139.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008FD3"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_23_",
    fill: "url(#SVGID_95_)",
    points: "256.714,127.336 244.933,90.967 225.75,84.719  "
  })))), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008FD3",
    points: "194.848,127.398 206.628,91.031 225.811,84.781  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.3169,
    y1: 54.8921,
    x2: 210.3169,
    y2: 12.2729,
    gradientTransform: "matrix(1 0 0 -1 0 139.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2637,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3697,
    style: {
      stopColor: "#DCE9F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6021,
    style: {
      stopColor: "#8AC0E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9416,
    style: {
      stopColor: "#0091D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#008FD3"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_26_",
    fill: "url(#SVGID_96_)",
    points: "194.835,127.391 225.782,104.947 225.798,84.771  "
  })))), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008FD3",
    points: "175.67,68.521 213.898,68.485 225.771,84.797  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.7754,
    y1: 59.9111,
    x2: 175.6743,
    y2: 59.9111,
    gradientTransform: "matrix(1 0 0 -1 0 139.6641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0385,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1679,
    style: {
      stopColor: "#E0ECF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    style: {
      stopColor: "#9BC8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#009CD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008FD3"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_29_",
    fill: "url(#SVGID_97_)",
    points: "175.675,68.505 206.583,91.002 225.776,84.783  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaradvertise);
export default __webpack_public_path__ + "static/media/staradvertise.cda8d95981326b2ad36c26487ffda585.svg";
export { ForwardRef as ReactComponent };